"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * MyBuy Backend API
 * ## Release Notes  ### v0.0.1  Work in progress
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.SessionStatusLoginStatusEnum = exports.SessionStatusToJSON = exports.SessionStatusFromJSONTyped = exports.SessionStatusFromJSON = void 0;
var runtime_1 = require("../runtime");
function SessionStatusFromJSON(json) {
    return SessionStatusFromJSONTyped(json, false);
}
exports.SessionStatusFromJSON = SessionStatusFromJSON;
function SessionStatusFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'loginStatus': !(0, runtime_1.exists)(json, 'loginStatus') ? undefined : json['loginStatus'],
    };
}
exports.SessionStatusFromJSONTyped = SessionStatusFromJSONTyped;
function SessionStatusToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'loginStatus': value.loginStatus,
    };
}
exports.SessionStatusToJSON = SessionStatusToJSON;
/**
* @export
* @enum {string}
*/
var SessionStatusLoginStatusEnum;
(function (SessionStatusLoginStatusEnum) {
    SessionStatusLoginStatusEnum["LoggedIn"] = "LoggedIn";
    SessionStatusLoginStatusEnum["GuestLogin"] = "GuestLogin";
    SessionStatusLoginStatusEnum["ForeignerLoggedIn"] = "ForeignerLoggedIn";
})(SessionStatusLoginStatusEnum = exports.SessionStatusLoginStatusEnum || (exports.SessionStatusLoginStatusEnum = {}));
//# sourceMappingURL=SessionStatus.js.map